var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"businessesDialog",attrs:{"id":"businessesDialog"},on:{"click":_vm.dialogActions}},[_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v("Businesses")]),_vm._v(" "),_c('businesses-layout',{attrs:{"businesses":_vm.businesses},scopedSlots:_vm._u([{key:"buttons",fn:function(ref){
var business = ref.business;
return [_c('p',[_c('large-button',{on:{"click":function($event){_vm.$emit('link',business);_vm.cancelDialog()}}},[_vm._v("Link")])],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a3ffd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BusinessesLinksDialog.vue
// module id = 857
// module chunks = 1